require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./loans-and-credit-cards-mortgage.json") })
        }
      }, "path---loans-and-credit-cards-mortgage");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---loans-and-credit-cards-mortgage!./.cache/json/loans-and-credit-cards-mortgage.json
// module id = 2592
// module chunks = 231608221292675